/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.buttongroup[_ngcontent-%COMP%], .entrypanel[_ngcontent-%COMP%], .smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-top:15px}.smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-bottom:15px}.entrypanel[_ngcontent-%COMP%]{padding:15px}.filter[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/managecourses/managecourses.component.css.shim.ngstyle.js.pre-build-optimizer.js